export default __webpack_public_path__ + "media/src/assets/fonts/Bitter-Regular-a3ca591980bea876ed4af2ac8e784358.ttf";